import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const BackupIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M15.97,6.71c-.34-3.3-3.29-5.69-6.59-5.34-2.82.29-5.05,2.52-5.34,5.34C1.48,7.06-.31,9.41.04,11.97c.32,2.31,2.29,4.04,4.63,4.03h3.33v-1.33h-3.33c-1.84,0-3.33-1.49-3.33-3.33s1.49-3.33,3.33-3.33h.67v-.67c0-2.58,2.09-4.66,4.67-4.66,2.58,0,4.66,2.09,4.66,4.66v.67h.67c1.84,0,3.33,1.49,3.33,3.33s-1.49,3.33-3.33,3.33h-3.33v1.33h3.33c2.58,0,4.67-2.09,4.67-4.66,0-2.33-1.72-4.31-4.03-4.62Z" />
  <path d="M12.86,12.14l.94-.94-3.8-3.8-3.8,3.8.94.94,2.19-2.19v8.72h1.33v-8.72l2.19,2.19Z" />
 </svg>,
 "Backup"
);
